import 'datatables.net-bs5'
import 'datatables.net-responsive-bs'

window.datatablesDefaults = {
  language: {
    paginate: {
      previous: '<span class="page-link">&nbsp;</span>',
      next: '<span class="page-link">&nbsp;</span>',
    },
    sSearch: '<span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="o-ico"><path d="m21 21-4.34-4.34"></path><circle cx="11" cy="11" r="8"></circle></svg></span>',
    emptyTable: 'Aucun résultat',
    sInfo: '_START_ à _END_ sur _TOTAL_',
    infoEmpty: '0 à 0 sur 0',
    infoFiltered: '(filtrée sur _MAX_)',
    zeroRecords: 'Aucun résultat',
    loadingRecords: 'Chargement ...',
    processing: 'Traitement ...',
    searchPlaceholder: 'Recherche',
    lengthMenu: 'Voir _MENU_'
  },
  classes: {
    sPageButton: 'page-item',
    sPageButtonActive: 'page-item',
  }
}

function toggleDisabledClass(checkboxClass, btnClass, inputClass) {
  let checkBoxes = document.querySelectorAll(checkboxClass)
  let checkCount = 0
  let checkIds = []

  checkBoxes.forEach((checkBox) => {
    const elementId = checkBox.dataset.id
    if (checkBox.checked) {
      checkCount += 1
      checkIds.push(elementId)
    } else {
      const index = checkIds.indexOf(elementId)
      if (index >= 0) {
        checkIds.splice(index, 1)
      }
    }
  })

  if (checkCount === 0) {
    $(btnClass).addClass('is-disabled')
    $('.distribute-btn').prop('disabled', true)
  } else {
    $(btnClass).removeClass('is-disabled')
    $('.distribute-btn').prop('disabled', false)
  }

  $(inputClass).val(checkIds.toString())
}

document.addEventListener('turbo:load', () => {
  // My classrooms
  $('#my-classrooms-checkboxes').on('click', function() {
    let checkBoxes = document.querySelectorAll('.my-classrooms-checkbox')
    checkBoxes.forEach((checkBox) => {
      checkBox.checked = $('#my-classrooms-checkboxes').is(':checked')
    })
    toggleDisabledClass('.my-classrooms-checkbox', '.my-classrooms-btn', '.my-classrooms-input')
  })

  $('.my-classrooms-checkbox').on('change', function() {
    toggleDisabledClass('.my-classrooms-checkbox', '.my-classrooms-btn', '.my-classrooms-input')
  })

  // Classrooms shared
  $('#classrooms-shared-checkboxes').on('click', function() {
    let checkBoxes = document.querySelectorAll('.classrooms-shared-checkbox')
    checkBoxes.forEach((checkBox) => {
      checkBox.checked = $('#classrooms-shared-checkboxes').is(':checked')
    })
    toggleDisabledClass('.classrooms-shared-checkbox', '.classrooms-shared-btn', '.classrooms-shared-input')
  })

  $('.classrooms-shared-checkbox').on('change', function() {
    toggleDisabledClass('.classrooms-shared-checkbox', '.classrooms-shared-btn', '.classrooms-shared-input')
  })

  // Students
  $('#students-checkboxes').on('click', function() {
    let checkBoxes = document.querySelectorAll('.students-checkbox')
    checkBoxes.forEach((checkBox) => {
      checkBox.checked = $('#students-checkboxes').is(':checked')
    })
    toggleDisabledClass('.students-checkbox', '.students-btn', '.students-input')
  })

  $('.students-checkbox').on('change', function() {
    toggleDisabledClass('.students-checkbox', '.students-btn', '.students-input')
  })
})
